import { initialize } from './errorHandler';

const { stackdriverKey, stackdriverProjectId } = window;
const errorHandler = initialize(stackdriverKey, stackdriverProjectId);

export { errorHandler };
